export const sansSerif = "freight-sans-pro, sans-serif";

export const numeric = "'Roboto', sans-serif";

export const heading = sansSerif;
export const body = sansSerif;



// WEBPACK FOOTER //
// ./src/styles/fonts.js